import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=73fbae33&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"
import style0 from "./OtpModal.vue?vue&type=style&index=0&id=73fbae33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fbae33",
  null
  
)

export default component.exports